export default class ContractsDetailed {
  number: string;

  id: string;

  constructor(obj: any) {
    this.number = obj.number;
    this.id = obj.id;
  }

  public static of(obj: any = {}): ContractsDetailed {
    return new ContractsDetailed(obj);
  }

  public static ofList(obj: any[]): ContractsDetailed[] {
    return obj.map(this.of)
  }
}
